export default __webpack_public_path__ + "static/share-aa8d8c8663aa24d5c74b6239544856a1.jpg";